import Vue from 'vue'
import App from './App.vue'
import router from './router/routers'
import '@/assets/iconfont/iconfont.css'

Vue.config.productionTip = false

new Vue({
    el: '#app',
    router,
    render: h => h(App),
})
